import React from 'react';
import { useState, useEffect } from 'react';
import { LandingPage } from './components/views/LandingPage';
import { Login } from './components/views/Login';
import { useAuth } from './hooks/useAuth';
import { Sidebar } from './components/ui/Sidebar';
import { Dashboard } from './components/views/Dashboard';
import { TenantSetup } from './components/views/TenantSetup';
import { TenantDashboard } from './components/views/TenantDashboard';
import { DatabaseStatus } from './components/views/DatabaseStatus';
import { Appointments } from './components/views/Appointments';
import { Predictions } from './components/views/Predictions';
import { ModelTesting } from './components/views/ModelTesting';
import { Analytics } from './components/views/Analytics';
import { Settings } from './components/views/Settings';
import { DataUpload } from './components/views/DataUpload';
import { Messages } from './components/views/Messages';

function App() {
  const { user, login, logout, loading, error } = useAuth();
  const [showLogin, setShowLogin] = useState(false);
  const [activeView, setActiveView] = useState('dashboard');

  useEffect(() => {
    if (error && !user) {
      setShowLogin(true);
    }
  }, [error, user]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (showLogin && !user) {
    return (
      <Login 
        onLogin={login} 
        error={error}
        onBack={() => setShowLogin(false)}
      />
    );
  }

  const isSuperAdmin = user?.role === 'super-admin';

  const renderActiveView = () => {
    switch (activeView) {
      case 'dashboard':
        return <Dashboard />;
      case 'tenant-setup':
        return isSuperAdmin ? <TenantSetup /> : <Dashboard />;
      case 'tenant-dashboard':
        return isSuperAdmin ? <TenantDashboard /> : <Dashboard />;
      case 'database-status':
        return <DatabaseStatus />;
      case 'appointments':
        return <Appointments />;
      case 'upload':
        return <DataUpload />;
      case 'predictions':
        return <Predictions />;
      case 'model-testing':
        return <ModelTesting />;
      case 'analytics':
        return <Analytics />;
      case 'messaging':
        return <Messages />;
      case 'integrations':
        return <Settings user={user} initialTab="integrations" />;
      case 'settings':
        return <Settings user={user} />;
      default:
        return <Dashboard />;
    }
  };
  if (user) {
    return (
      <div className="flex min-h-screen bg-gray-100">
        <Sidebar 
          user={user}
          activeView={activeView}
          onViewChange={setActiveView}
          onLogout={logout}
        />
        <div className="flex-1">
          {renderActiveView()}
        </div>
      </div>
    );
  }

  return <LandingPage onShowLogin={() => setShowLogin(true)} />;
}

export default App;